import React, { useState, useEffect } from 'react';
import AdminLayout from '../components/layouts/AdminLayout';
import ContentManager from './website-admin/ContentManager';
import ContentEditor from './website-admin/ContentEditor';
import ApprovalSubmissions from './website-admin/ApprovalSubmissions';
import TestimonialApproval from './website-admin/TestimonialApproval';
import DashboardOverviewWA from './website-admin/DashboardOverview';
import '../styles/dashboard.css';
import './website-admin/WebsiteAdminDashboard.css';

function WebsiteAdminDashboard({ user, onLogout, apiBase }) {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [stats, setStats] = useState({
    totalContent: 0,
    draftContent: 0,
    pendingApproval: 0,
    publishedContent: 0,
    pendingTestimonials: 0
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const response = await fetch(`${apiBase}/contents?limit=1`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();
      if (data.ok && data.data?.pagination) {
        setStats(prev => ({
          ...prev,
          totalContent: data.data.pagination.total || 0
        }));
      }
    } catch (err) {
      console.error('Error loading stats:', err);
    }
  };

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3" />
          <polyline points="12 12 20 7.5" />
          <polyline points="12 12 12 21" />
          <polyline points="12 12 4 7.5" />
        </svg>
      )
    },
    {
      id: 'content',
      label: 'Ubah Konten',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="12" y1="11" x2="12" y2="17" />
          <line x1="9" y1="14" x2="15" y2="14" />
        </svg>
      )
    },
    {
      id: 'submissions',
      label: 'Pengajuan Approval',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 11l3 3L22 4" />
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
        </svg>
      ),
      badge: stats.pendingApproval > 0 ? stats.pendingApproval : null
    },
    {
      id: 'testimonials',
      label: 'Testimonial Approval',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          <path d="M9 10h.01M14 10h.01" />
        </svg>
      ),
      badge: stats.pendingTestimonials > 0 ? stats.pendingTestimonials : null
    }
  ];

  const roleColor = '#10b981';
  const dashboardTitle = 'Website Admin';

  return (
    <AdminLayout
      user={user}
      onLogout={onLogout}
      roleColor={roleColor}
      dashboardTitle={dashboardTitle}
      menuItems={menuItems}
      activeTab={activeTab}
      onTabChange={setActiveTab}
    >
      <div className="dashboard-content">
        {/* Dashboard Tab */}
        {activeTab === 'dashboard' && (
          <DashboardOverviewWA apiBase={apiBase} stats={stats} onRefresh={loadStats} />
        )}

        {/* Content Manager Tab */}
        {activeTab === 'content' && (
          <ContentManager apiBase={apiBase} roleColor={roleColor} />
        )}

        {/* Approval Submissions Tab */}
        {activeTab === 'submissions' && (
          <ApprovalSubmissions apiBase={apiBase} roleColor={roleColor} />
        )}

        {/* Testimonial Approval Tab */}
        {activeTab === 'testimonials' && (
          <TestimonialApproval apiBase={apiBase} roleColor={roleColor} />
        )}
      </div>
    </AdminLayout>
  );
}

export default WebsiteAdminDashboard;
